<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const prompt = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val),
});

const charCount = computed(() => (prompt.value ? prompt.value.length : 0));
const wordCount = computed(() => {
  if (!prompt.value) return 0;
  return prompt.value.trim().split(/\s+/).filter(Boolean).length;
});
</script>

<template>
  <div class="space-y-4 max-w-4xl">
    <div class="bg-n-surface-1 border border-n-weak rounded-xl p-6 space-y-4">
      <div class="flex items-center justify-between">
        <div>
          <h3 class="text-base font-semibold text-n-slate-12">
            Prompt Principal do Agente
          </h3>
          <p class="text-xs text-n-slate-11">
            Instruções completas do comportamento da Isa Leal, regras de
            conversação, tom e fluxo.
          </p>
        </div>
        <div
          class="flex items-center gap-4 text-xs font-mono text-n-slate-11 bg-n-surface-2 px-3 py-1.5 rounded-lg border border-n-weak"
        >
          <span>{{ charCount }} caracteres</span>
          <span>•</span>
          <span>{{ wordCount }} palavras</span>
        </div>
      </div>

      <div>
        <textarea
          v-model="prompt"
          rows="18"
          placeholder="Você é a Isa Leal, assistente de atendimento virtual da Empresa Acme...

### IDENTIDADE & REGRAS
- Fale sempre em português claro e cordial.
- Apresente-se como Isa Leal.
- Responda apenas com base nas ferramentas fornecidas."
          class="reset-base !mb-0 w-full text-sm font-mono bg-n-surface-2 border border-n-weak rounded-lg p-4 text-n-slate-12 focus:border-n-brand outline-none resize-y leading-relaxed"
        />
      </div>
    </div>
  </div>
</template>
